import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./NoStyleButton.css";

export default function NoStyleButton({
  className,
  trackingClassName,
  onClick,
  ariaLabel,
  children,
}) {
  return (
    <button
      aria-label={ariaLabel}
      onClick={onClick}
      className={classNames(styles.root, trackingClassName)}
    >
      <span className={classNames(styles.noFocus, className)} tabIndex="-1">
        {children}
      </span>
    </button>
  );
}

NoStyleButton.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  trackingClassName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
